import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=9ba87bb4"
import script from "./bar.ts?vue&type=script&lang=js&external"
export * from "./bar.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports